export const TEXT_STYLES = {
  default: {
    label: "Generic",
    style: "font",
    fontFamily: "Arial",
    fontVariant: "normal",
  },
  cursive: {
    label: "Cursive",
    style: "cursive-font",
    fontFamily: "Brush Script MT",
    fontVariant: "italic",
  },
  english: {
    label: "Old English",
    style: "old-english-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
  script: {
    label: "Script",
    style: "script-font",
    fontFamily: "Brush Script MT",
    fontVariant: "italic",
  },
  traditional: {
    label: "Traditional",
    style: "traditional-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
  gothic: {
    label: "Gothic",
    style: "gothic-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
  typewriter: {
    label: "Typewriter",
    style: "typewriter-font",
    fontFamily: "Courier New",
    fontVariant: "bold",
  },
  roman: {
    label: "Roman",
    style: "roman-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
  chicano: {
    label: "Chicano",
    style: "chicano-font",
    fontFamily: "Courier New",
    fontVariant: "bold",
  },
  calligraphy: {
    label: "Calligraphy",
    style: "calligraphy-font",
    fontFamily: "Brush Script MT",
    fontVariant: "italic",
  },
  graffiti: {
    label: "Graffiti",
    style: "graffiti-font",
    fontFamily: "Brush Script MT",
    fontVariant: "italic",
  },
  gangster: {
    label: "Gangster",
    style: "gangster-font",
    fontFamily: "Courier New",
    fontVariant: "bold",
  },
  stencil: {
    label: "Stencil",
    style: "stencil-font",
    fontFamily: "Arial",
    fontVariant: "normal",
  },
  handwritten: {
    label: "Handwritten",
    style: "handwritten-font",
    fontFamily: "Brush Script MT",
    fontVariant: "italic",
  },
  minimalist: {
    label: "Minimalist",
    style: "minimalist-font",
    fontFamily: "Arial",
    fontVariant: "normal",
  },
  block: {
    label: "Block",
    style: "block-font",
    fontFamily: "Courier New",
    fontVariant: "bold",
  },
  dark: {
    label: "Dark",
    style: "dark-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
  classic: {
    label: "Classic",
    style: "classic-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
  western: {
    label: "Western",
    style: "western-font",
    fontFamily: "Courier New",
    fontVariant: "bold",
  },
  blackletter: {
    label: "Blackletter",
    style: "blackletter-font",
    fontFamily: "Garamond",
    fontVariant: "normal",
  },
} as const;

// Helper type for accessing text style keys
export type TextStyleKey = keyof typeof TEXT_STYLES;

// Helper function to get all text style options in the original format for backwards compatibility
export const getTextStyleOptions = () =>
  Object.entries(TEXT_STYLES).map(([value, config]) => ({
    value,
    label: config.label,
  }));
